module.exports = __webpack_public_path__ + "img/category.afc7030e.png";